import { DialogContent } from "@mui/material";
import styled from "styled-components";

import Input from "components/Input";

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentContainer = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentParagraphContainer = styled.div`
  display: grid;
  gap: 24px;
`;

export const InputTextContainer = styled.div`
  text-align: center;
`;

export const InputText = styled(Input)`
  width: 70%;
`;
